<template>
  <path
    fill="currentColor"
    d="M7.058 7.537a.75.75 0 0 1 .162-.817l4.5-4.5a.75.75 0 0 1 1.061 0l4.5 4.5a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.693-.463m9.693 7.964h-9a.75.75 0 0 0-.531 1.28l4.5 4.5a.75.75 0 0 0 1.061 0l4.5-4.5a.75.75 0 0 0-.53-1.28"
  />
</template>
